// Function to colour polygons
export const colourPolygons = function (d, variable, scale, colPalette) {
  // Define the color for "Insufficient Data"
  const noDataColor = "#808080";

  // Check if d is null or undefined
  if (d === null || d === undefined) {
    return noDataColor;
  }

  // Burned Area Anomaly in Final Year
  // prettier-ignore
  return d < scale[8] ? colPalette[8] :
          d >= scale[8] && d < scale[7] ? colPalette[7] :
          d >= scale[7] && d < scale[6] ? colPalette[6] :
          d >= scale[6] && d <= scale[5] ? colPalette[5] :
          d > scale[5] && d < scale[4] ? colPalette[5] :
          d >= scale[4] && d < scale[3] ? colPalette[4] :
          d >= scale[3] && d < scale[2] ? colPalette[3] :
          d >= scale[2] && d < scale[1] ? colPalette[2] :
          d >= scale[1] && d < scale[0] ? colPalette[1] : colPalette[0];
};

// Function to render popup content
export const popupContent = function (properties) {
  return `
    <h4 class="text-start">${properties.reg_name}</h4>
    <h6 class="text-start">2025-26 fire season anomalies from the average fire season and rankings amongst all fire seasons.</h6>
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-start" scope="col">Variable</th>
          <th class="text-end" scope="col">%</th>
          <th class="text-end" scope="col">Rank</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-start">Burned Area Anomaly</td>
          <td class="text-end">${
            properties.ba_anom !== null
              ? properties.ba_anom > 0
                ? `+${properties.ba_anom}`
                : properties.ba_anom
              : `Insufficient Data`
          }</td>
          <td class="text-end">${properties.ba_rank !== null ? properties.ba_rank : "n/a"}</td>
        </tr>
        <tr>
          <td class="text-start">Carbon Emitted Anomaly</td>
          <td class="text-end">${
            properties.cem_emAn !== null
              ? properties.cem_emAn > 0
                ? `+${properties.cem_emAn}`
                : properties.cem_emAn
              : `Insufficient Data`
          }</td>
          <td class="text-end">${properties.cem_emRk !== null ? properties.cem_emRk : "n/a"}</td>
        </tr>
        <tr>
          <td class="text-start">Number of Fires Anomaly</td>
          <td class="text-end">${
            properties.gfa_nFAnP !== null
              ? properties.gfa_nFAnP > 0
                ? `+${properties.gfa_nFAnP}`
                : properties.gfa_nFAnP
              : `Insufficient Data`
          }</td>
          <td class="text-end">${properties.gfa_nFRk !== null ? properties.gfa_nFRk : "n/a"}</td>
        </tr>
        <tr>
          <td class="text-start">95ᵗʰ Percentile Fire Size Anomaly</td>
          <td class="text-end">${
            properties.gfa_95FAP !== null
              ? properties.gfa_95FAP > 0
                ? `+${properties.gfa_95FAP}`
                : properties.gfa_95FAP
              : `Insufficient Data`
          }</td>
          <td class="text-end">${properties.gfa_95FRk !== null ? properties.gfa_95FRk : "n/a"}</td>
        </tr>
        <tr>
          <td class="text-start">95ᵗʰ Percentile Rate of Growth Anomaly</td>
          <td class="text-end">${
            properties.gfa_95RAP !== null
              ? properties.gfa_95RAP > 0
                ? `+${properties.gfa_95RAP}`
                : properties.gfa_95RAP
              : `Insufficient Data`
          }</td>
          <td class="text-end">${properties.gfa_95RRk !== null ? properties.gfa_95RRk : "n/a"}</td>
        </tr>
        ${
          properties.frp_95dPc !== null && properties.frp_95dPc !== undefined
            ? `
        <tr>
          <td class="text-start">Average Fire's 95ᵗʰ Percentile FRP (MW) Anomaly</td>
          <td class="text-end">${properties.frp_95dPc > 0 ? `+${properties.frp_95dPc}` : properties.frp_95dPc}</td>
          <td class="text-end">${properties.frp_95r !== null ? properties.frp_95r : "n/a"}</td>
        </tr>`
            : ""
        }
      </tbody>
    </table>
    `;
};
